/**
 * Shimmering placeholder shown in the content area while a table's
 * metadata + first page of rows are loading. Mantine `Skeleton` provides
 * the shimmer; we render enough rows to fill the viewport and let the
 * column widths flex evenly so the placeholder occupies the same visual
 * footprint as the real grid.
 */
import { Skeleton } from "@mantine/core";

const COL_WIDTHS = ["72%", "55%", "48%", "62%", "40%"];
const ROW_VARIANTS = [
  ["55%", "30%", "85%", "42%", "20%"],
  ["38%", "60%", "44%", "70%", "32%"],
  ["80%", "25%", "55%", "48%", "60%"],
  ["46%", "72%", "30%", "55%", "44%"],
  ["66%", "40%", "75%", "32%", "52%"],
];

export function TableSkeleton({
  rows = 30,
  cols = COL_WIDTHS.length,
}: {
  rows?: number;
  cols?: number;
}) {
  return (
    <div className="kse-skel">
      <table className="kse-skel__table">
        <thead>
          <tr>
            {Array.from({ length: cols }).map((_, i) => (
              <th key={i}>
                <Skeleton
                  height={12}
                  width={COL_WIDTHS[i % COL_WIDTHS.length]}
                  radius="sm"
                />
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {Array.from({ length: rows }).map((_, r) => (
            <tr key={r}>
              {Array.from({ length: cols }).map((_, c) => (
                <td key={c}>
                  <Skeleton
                    height={10}
                    width={ROW_VARIANTS[r % ROW_VARIANTS.length]![c % cols]!}
                    radius="sm"
                  />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
